import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RefundVouchersFormDataBuilderInterface } from '../refund-vouchers/interface/form-data.builder.interface';
import { RefundFormComponent } from '../refund-form.component';

@Component({
  template: ''
})
export abstract class RefundVouchersFormComponent extends RefundFormComponent implements OnInit {
  _formValues: RefundVouchersFormDataBuilderInterface;
  @Input() set formValues(model: RefundVouchersFormDataBuilderInterface) {
    this._formValues = model;

    if (this.refundForm) {
      this.refundForm.setValue({
        voucherNumber: model.voucherNo || '',
        email: model.email || ''
      });
      this.refundForm.updateValueAndValidity();
    }
  }

  getFrom(): FormGroup {
    return this.getFormGroup({ ...this._formValues });
  }

  abstract getFormGroup(formDataBuilderInterface: RefundVouchersFormDataBuilderInterface): FormGroup;
}
